module.exports = __webpack_public_path__ + "img/lips_ios_802.png";